import type { ReactiveController, ReactiveControllerHost } from "lit";

import { previewStore } from "./preview-store";

export class PreviewController implements ReactiveController {
  constructor(private host: ReactiveControllerHost) {
    host.addController(this);
  }

  get isPreviewMode() {
    return previewStore.isPreviewMode;
  }

  hostConnected() {
    // Set preview-mode attribute on host element for CSS targeting
    if (this.isPreviewMode && "setAttribute" in this.host) {
      (this.host as unknown as HTMLElement).setAttribute("preview-mode", "");
    }
  }

  hostDisconnected() {
    // Cleanup if needed
  }
}
